import { Form } from 'react-bootstrap'
import { Radio } from 'antd'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { SynchronousCourseTypes } from 'enum'
import { useField } from '../../../context'

export const SynchronousInput = () => {
  const { value, change, error } = useField('courseTypeSynchronous')
  const t = useTranslationRankmi({
    prefix: 'administration.courses.new.form.courseType.synchronousTypes',
  })
  const options = [
    {
      value: SynchronousCourseTypes.external,
      label: t('external'),
    },
    {
      value: SynchronousCourseTypes.faceToFace,
      label: t('faceToFace'),
    },
  ]

  return (
    <Form.Group>
      <Radio.Group value={value} onChange={(e) => change(e.target.value)}>
        {options.map((option, index) => (
          <Radio.Button key={index} value={option.value}>
            {option.label}
          </Radio.Button>
        ))}
      </Radio.Group>
    </Form.Group>
  )
}
